import React, { useEffect } from 'react';
import { getImageUrl } from '../../../../utils/image-helper/get-image-url';
import { useDispatch } from 'react-redux';
import { setSelectedMenuItemKeys } from '../../../../redux/reducer/antd-layout-info.reducer';

export const MaintainerDashboard = () => {
    const dispatch = useDispatch();
    
    useEffect(() => {
        dispatch(setSelectedMenuItemKeys(['maintainer-dashboard']));
    }, [dispatch]);

    return (
        <>
            <div className="page-title">Főoldal</div>
        </>
    )
}